<template>
  <!-- Nothing at all when no such filter is on, so a page reached from the menu
       looks exactly as it did before. -->
  <div v-if="chips.length" class="list-filter-chips mb-3">
    <v-chip v-for="chip in chips" :key="chip.field" size="small" closable class="mr-2 mb-1"
      @click:close="$emit('clear', chip.field)">{{ chip.label }}</v-chip>
  </div>
</template>

<script>
/*
 * The filters a list page was opened with that it has no form control for.
 *
 * A dashboard card links here with its own filter in the query string —
 * "tegemata hooldus 14 päeva", "pole loginud 6 päeva" — and listMixin feeds
 * that straight into the request. Without this the reader lands on a list that
 * is inexplicably short, with nothing on the page to say why and no way back
 * but editing the address bar.
 *
 * Only fields named in `labels` are drawn: a filter the page does have a
 * control for is already visible in that control, and saying it twice would be
 * worse than not saying it.
 */
export default {
  props: {
    // The page's own `search` object, as listMixin spreads it into params.
    search: { type: Object, required: true },
    // field -> label. A string, or a function of the value for a filter whose
    // number belongs in the words ("Hoolduse tähtaeg 14 päeva").
    labels: { type: Object, required: true }
  },
  computed: {
    chips () {
      return Object.keys(this.labels)
        // '' is how listMixin spells "not filtering by this"; 0 is a real
        // value for some of them (paymentType=0 is "maksmata"), so only the
        // empty string and null/undefined are absent.
        .filter(field => {
          const value = this.search[field]
          if (value === '' || value == null) return false
          // An empty list is no filter either — `category` clears to [].
          return !Array.isArray(value) || value.length > 0
        })
        .map(field => {
          const label = this.labels[field]
          return {
            field,
            label: typeof label === 'function' ? label(this.search[field]) : label
          }
        })
    }
  }
}
</script>
